import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the EnterpriseTermRevision EC used to pick the TARGET term of a synonym.
// Display = the term's Name; value = EnterpriseTermUSID (the logical parent term, NOT the revision)
// so the synonym tracks the term's current published wording rather than a frozen revision. Only
// RELEASED revisions are offered (the EC's statusesFilter default = DEFAULT_STATUSES), and since a
// term has at most one published revision this lists one row per publishable term.
class SynonymTermPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "SynonymTerm";
        this.static = false;
        this.enterpriseComponent = "EnterpriseTermRevision";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "EnterpriseTermUSID";
        this.allowNoSelection = false;
        // A term cannot be its own synonym: exclude the source term's EnterpriseTermUSID, stamped on
        // the TermSynonym EC by TermSynonymFormApplet.setAction (not a rendered control, so this uses
        // the EC-attribute exclusion rather than excludeFormFields).
        this.excludeEnterpriseComponentAttributes = ["SourceTermUSID"];
    }
}

export default SynonymTermPicklistMetadata;
